import React, { Component } from 'react';
import { Col, FormGroup, Row } from 'reactstrap';
import HtmlHelpers from '../../HtmlHelpers';
export default class WmTextField extends Component {
  constructor() {
    super(...arguments);
    this.inRow = content => /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns,
      xs: 12 - Math.max(parseInt(this.props.labelColumns, 10), 0)
    }, content, /*#__PURE__*/React.createElement("div", {
      className: "invalid-feedback"
    }));
    this.withInputGroup = (inputGroup, content) => this.inRow(inputGroup ? /*#__PURE__*/React.createElement("div", {
      className: "input-group"
    }, inputGroup && inputGroup.prepend ? inputGroup.textMethod() : '', content, inputGroup && inputGroup.append ? inputGroup.textMethod() : '') : content);
    this.getTextField = () => this.withInputGroup(this.props.inputGroup, /*#__PURE__*/React.createElement("input", {
      type: this.props.fieldType,
      className: "form-control",
      required: this.props.isRequired,
      autoFocus: this.props.focus,
      name: this.props.name,
      value: this.props.value,
      onChange: this.props.onChange,
      min: this.props.min,
      max: this.props.max,
      step: this.props.step,
      readOnly: this.props.readOnly,
      pattern: this.props.pattern,
      title: this.props.title,
      maxLength: this.props.maxLength,
      minLength: this.props.minLength,
      autoComplete: this.props.autoComplete
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, HtmlHelpers.getWmLabel(this.props), this.getTextField(), HtmlHelpers.isEmpty(this.props.buttonAfter) ? '' : ' ', this.props.buttonAfter));
  }
}
WmTextField.defaultProps = {
  isRequired: true
};